import { TenantState } from '@zaoblako/web/modules/admin/components/tenant/card/models/tenant-state';

export const tenantInitialState: TenantState = {
  loading: true,
  tenant: null,
  panelsInfo: {
    ratePlanShow: true,
    historyShow: true,
    transactionsShow: true,
    statisticsShow: true
  },
  statisticsInfo: {
    statistics: null,
    loading: true
  },
  historyInfo: {
    count: 0,
    queryParams: {
      limit: 20,
      offset: 0
    },
    items: [],
    loading: true,
    paginationLoading: false
  },
  transactionsInfo: {
    count: 0,
    queryParams: {
      limit: 20,
      offset: 0
    },
    items: [],
    loading: true,
    paginationLoading: false
  },
  ratePlans: []
};
